/* ag-p30-cart (2026-09-30): intentionally empty. The round-1 cart-controller patch and checkout
   interception were withdrawn after a GPT-6 Astra NO-SHIP review (remove sent line:0; the guard could swallow the
   first checkout tap) and a live re-test showed the qty "+" works on the real customer path. CSS-only fixes remain. */
/* owner 2026-09-30: add-ons sheet scroll hint (markup in snippets/ag-addons.liquid). Shows the fade + arrow only while the
   list overflows and the shopper is not at its end; the arrow scrolls the list by most of a screen. No layout reads in any
   click path; sync runs from ResizeObserver and a passive, rAF-throttled scroll listener on the sheet's own scroller. */
(function () {
  'use strict';
  function wire(body) {
    if (!body || body.__agMore) return;
    var more = body.querySelector('[data-ag-addon-more]');
    if (!more) return;
    body.__agMore = true;
    var raf = 0;
    function sync() {
      raf = 0;
      var overflow = body.scrollHeight - body.clientHeight > 8;
      more.hidden = !overflow;
      if (overflow) more.classList.toggle('is-end', body.scrollTop + body.clientHeight >= body.scrollHeight - 24);
    }
    function schedule() { if (!raf) raf = window.requestAnimationFrame(sync); }
    body.addEventListener('scroll', schedule, { passive: true });
    var btn = more.querySelector('[data-ag-addon-more-btn]');
    if (btn) btn.addEventListener('click', function () {
      try { body.scrollBy({ top: Math.round(body.clientHeight * 0.75), behavior: 'smooth' }); }
      catch (e) { body.scrollTop += Math.round(body.clientHeight * 0.75); }
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      ro.observe(body);
      var list = body.querySelector('.ag-atc-addon__list');
      if (list) ro.observe(list);
    }
    schedule();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ag-addon-scroll]'), wire); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
